import React, { PropsWithChildren } from 'react'
import { StyleBreadCrumbLetter, StyledBreadcrumbContainer, StyledBreadcrumbItem } from './StyledGlossary'

export type GlossaryBreadcrumbProps = {
  letters: string[]
  selectedLetter: string
} & React.ComponentProps<typeof StyleBreadCrumbLetter>

export const GlossaryBreadcrumb: React.FC<PropsWithChildren<GlossaryBreadcrumbProps>> = ({ letters, selectedLetter, ...props }) => {
  return (
    <StyledBreadcrumbContainer {...props} container item justifyContent="center" alignItems="center">
      {
        letters.map((text, key) =>
          <StyledBreadcrumbItem key={key} variant="body1">
            <StyleBreadCrumbLetter className={text === selectedLetter ? 'selected' : ''} href={`#${text}`}>
              {text}
            </StyleBreadCrumbLetter>
          </StyledBreadcrumbItem>)
      }
    </StyledBreadcrumbContainer>
  )
}